export default {
  title01: "Поточна погода",
  title02: "24 години",
  title03: "Подивитися прогноз погоди на наступні 10 днів",
  title04: "Інформація про якість повітря (AQI)",
  title05: "Подивитися всю інформацію",
  title06: "Схід та захід сонця",
  title07: "Фаза місяця",
  title08: "Наступий повний місяць",
  title09: "Наступний молодий місяць",
  title10: "День",
  title11: "Ніч",
  title12: "Світанок",
  title13: "Захід сонця",
  title14: "Схід місяця",
  title15: "Захід місяця",
  title16: "Джерело",
  title17: "Початок",
  title18: "Кінець",
  title19: "Використовувати поточну локацію",
  title20: "Шукати місто",
  title21: "Відчуваеться як",
  title22: "Відчуваеться як (у затінку)",
  title23: "Зараз",
  title24: "Сьогодні",
  title25: "Нд",
  title26: "Пн",
  title27: "Вт",
  title28: "Ср",
  title29: "Чт",
  title30: "Пт",
  title31: "Сб",
  title32: "Завантаження",
  title33: "Зараз",
  title34: "Погодинно",
  title35: "По дням",
  title36: "Сонце і Місяць",
  title37: "Якість повітря",
  title38: "Зв'язатися за : xlf550402@gmail.com",
  title39: "Угода про конфіденційність",
  title40: "Авторське право © comfortweather.com 2020 - 2024. Всі права зарезервовані.",
  title41: "Інформація надана [LOGO]",
  title42: "Високо",
  title43: "Низько",
  title44: "Прийняти",
  title45:
    "Дякуємо Вам за використання ComfortWeather! Для покращення захисту ваших законних прав та інтересів, уважно прочитайте ",
  title46: "Політику конфіденційності",
  title47: " перед використанням.",
  title48: "",
  title49: "Зв'язатися за : xyjph123@gmail.com",
  title50: "Авторське право © 24hweather.com 2020 - 2024. Всі права зарезервовані.",
  title51:
    "Дякуємо Вам за використання 24hweather! Для покращення захисту ваших законних прав та інтересів, уважно прочитайте ",
};
